import React, { useEffect, useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { useSocket } from '@/hooks/useSocket';
import { toast } from '@/components/ui/use-toast';
import { Button } from '@/components/ui/button';
import type { NotificationEvent } from '@/lib/socket';

export function NotificationToastProvider() {
  const { on, off } = useSocket();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const handleNotification = useCallback(
    (notification: NotificationEvent) => {
      const actionUrl = notification.data?.actionUrl as string | undefined;

      toast({
        title: notification.title,
        description: notification.body,
        action: actionUrl
          ? React.createElement(
              Button,
              {
                variant: 'outline',
                size: 'sm',
                onClick: () => navigate(actionUrl),
              },
              'View'
            )
          : undefined,
      });

      // Invalidate notifications cache so the list updates
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
    [queryClient, navigate]
  );

  useEffect(() => {
    on('notification', handleNotification);
    return () => {
      off('notification', handleNotification);
    };
  }, [on, off, handleNotification]);

  return null;
}
